export default "__VITE_ASSET__08695629__"